/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useState, useEffect } from "react";
import FormFilter from "../../shared/forms/FormFilter/FormFilter";
import useForm from "../../shared/forms/useForm";
import Filters from "../../shared/forms/FormFilter/Filters";
import Field from "../../shared/forms/Field";
import FormTextBox from "../../shared/forms/FormFields/FormTextBox";
import Buttons from "../../shared/forms/FormFilter/Buttons";
import ButtonIcon from "../../shared/controls/ButtonIcon";
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import agGridHelper from "../../shared/ag-grid-helper";
import FormMultiSelect from "../../shared/forms/FormFields/FormMultiSelect";
import FormCalendarRange from "../../shared/forms/FormFields/FormCalendarRange";
import FormCalendar from "../../shared/forms/FormFields/FormCalendar";
import moment from "moment";
import { FormattedDate } from "react-intl";
import RequisicionDetalle from "./requisicionDetalle";
import constantesAdministracion from "../../administracion/constantes";
import useApiRequisicion from "../../api/taller/useApiRequisicion";
import { Dialog } from "primereact/dialog";
import FieldTextArea from "../../shared/controls/fieldTextArea";
import { serialize } from "object-to-formdata";
import { Button } from "primereact/button";
import { OverlayPanel } from "primereact/overlaypanel";
import ExColumn from "../../shared/Grid/ExColumn";
import ExGrid from "../../shared/Grid/ExGrid";
import Articulos from "./Edicion/articulos";
import FieldMultiSelect from "../../shared/controls/fieldMultiSelect";
import constantesPrincipal from "../../catalogos/constantes";
import useSeguridad from "../../Seguridad/useSeguridad";
import FormDropDown from "../../shared/forms/FormFields/FormDropDown";
import { Dropdown } from "primereact/dropdown";
import alerts from "../../shared/alerts";
import { fechaRenderer } from "../../shared/Grid/GridCellRenderers";
// import useSessionState from "../../hooks/useSessionState";

const filtroInicial = {
  fecha: [moment().startOf("month")._d, moment().startOf("day")._d],
  unidadId: 0,
};
const Requisicion = ({ esSeccionAutorizar, onClose, idOrdenTrabajo }) => {
  const apiReq = useApiRequisicion();
  const [datos, setDatos] = useState([]);
  const [requisicionId, setrequisicionId] = useState(null);
  const {
    values: filter,
    onChange: onFilterChange,
    onClear,
  } = useForm(filtroInicial);
  const [id, setId] = useState(null);
  //const filtroKey = "FiltroRequisiciones";
  const [verRechazarModal, setVerRechazarModal] = useState(false);
  const [comentario, setComentario] = useState("");
  const op = useRef(null);
  const [articulos, setArticulos] = useState([]);
  const [requisicionSeleccionada, setRequisicionSeleccionada] = useState(null);
  const [agregarArticulos, setAgregarArticulos] = useState(false);
  const seguridad = useSeguridad();
  const soloLectura = !seguridad.esEditable(
    constantesPrincipal.menus.requisiciones
  );
  const puedeEditar = seguridad.esEditable(
    constantesPrincipal.menus.requisicionesEditar
  );
  const crearRequisiciones = seguridad.esEditable(
    constantesPrincipal.menus.requisicionesCrear
  );
  const [estatusRequisicionesArticulos, setEstatusRequisicionesArticulos] =
    useState([]);
  const [, setGridApi] = useState(null);
  const byOrdenTrabajo = idOrdenTrabajo != null ? false : true;
  const [verModal, setVerModal] = useState(false);
  const [requisicionIdARechazar, setRequisicionIdARechazar] = useState(null);
  //const [...setFiltro] = useSessionState(filtroKey, {}, filtroInicial);
  const [filtroState, setFiltroState] = useState(null);

  useEffect(() => {
    if (filtroInicial) {
      filtrar(filtroInicial);
    }
  }, []);
  const filtrar = async (filtro) => {
    const sourceFiltro = filtro ?? filter;
    const newFiltro = {
      ...sourceFiltro,
      estatusId: (filtro.estatusId || []).map((x) => x.id),
    };
    setFiltroState(newFiltro);
    const datos = await apiReq.filtrar(newFiltro);
    console.log("🚀 ~ filtrar ~ datos:", datos)
    setDatos(datos);
  };

  const nuevoCargo = (id) => {
    setId(id);
    setAgregarArticulos(true);
  };
  const onGridReady = async (params) => {
    setGridApi(params.api);
  };
  useEffect(() => {
    const fetchSource = async () => {
      //Para estatus de requisiciones articulos
      const data = await apiReq.getEstatus();
      //console.log('estatusRequisicionesArticulos', data);
      setEstatusRequisicionesArticulos(data);
    };

    fetchSource().then();
  }, []);

  // Create a helper function to find status name
  const getEstatusNombre = (estatusId) => {
    const estatus = estatusRequisicionesArticulos.find(
      (e) => e.id === estatusId
    );
    return estatus ? estatus.nombre : "";
  };

  async function asignar(api) {
    let rows = api.getSelectedRows();
    if (rows.length === 0) {
      alerts.aviso("Debe seleccionar mínimo una requisicion para asignar");
      return;
    }

    if (
      (await alerts.preguntarSiNo("¿Está seguro de generar la asignación?")) ===
      true
    ) {
      try {
        const ids = rows.map((e) => e.id).join(",");
        console.log(ids);
        await apiReq.asignarOrdenTrabajo(idOrdenTrabajo, ids);
      } catch (error) {
        console.error("Error al generar la asignación:", error);
        alerts.error(
          "Se produjo un error al generar la asignación. Por favor, inténtelo de nuevo."
        );
      } finally {
      }
    } else {
    }
  }

  const ButtonsHeader = (props) => {
    const api = props.api;
    const { filtroState } = props;

    const exportar = async () => {
      if (!filtroState) {
        console.error("filtroState es null");
        return;
      }
      const params = {};
      if (filtroState.folio) {
        params.folio = filtroState.folio;
      }
      if (filtroState.fecha?.length >= 1) {
        params.fecha = filtroState.fecha;
      }
      if (filtroState.solicitanteIds?.length) {
        params.solicitanteIds = filtroState.solicitanteIds;
      }
      if (filtroState.estatusId?.length) {
        params.estatusId = filtroState.estatusId;
      }
      if (filtroState.almacenId) {
        params.almacenId = [filtroState.almacenId];
      }
      if (filtroState.unidadId) {
        params.unidadId = [filtroState.unidadId];
      }
      //console.log("export Params", params);
      await apiReq.excel(params);
    };

    return (
      <div
        className={"ag-grid header-icons"}
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <ButtonIcon
          title={"Descargar"}
          onClick={exportar}
          iconName={"BiDownload"}
        />
        {!byOrdenTrabajo && (
          <ButtonIcon
            onClick={() => asignar(api)}
            title="Asignar"
            iconName="BiListCheck"
          />
        )}

        {crearRequisiciones && (
          <ButtonIcon
            title="Agregar"
            className={"grid-action"}
            iconName={"MdAddBox"}
            onClick={() => setrequisicionId(0)}
          />
        )}
      </div>
    );
  };

  const DateCellRenderer = ({ value }) => (
    <div>
      <FormattedDate value={value} weekday="short" /> &nbsp;
      {moment(value).format("DD/MM/YYYY")}
    </div>
  );
  const ButtonsDetail = ({ data, context }) => (
    <div className={"ag-grid row-icons"}>
      <ButtonIcon
        title={"Agregar Articulos"}
        iconName={"MdAddBox"}
        onClick={() => nuevoCargo(data.id)}
      />

      {puedeEditar && (
        <ButtonIcon
          title={"Editar"}
          iconName={"FaRegEdit"}
          onClick={() => context.onEdit(data.id)}
        />
      )}
    </div>
  );
  async function autorizar(id, esRechazar = false) {
    if (esRechazar) {
      setComentario("");
      setVerModal(true);
      setRequisicionIdARechazar(id);
    } else {
      if (
        await alerts.preguntarSiNo(
          `${
            esRechazar ? "Rechazar requisicion" : "Autorizar requisicion"
          }, ¿deseas continuar?`
        )
      ) {
        await apiReq.autorizar(id);
        await filtrar();
      }
    }
  }

  const rechazarApi = async (id) => {
    await apiReq.rechazar(id, { comentario });
    setVerModal(false);
    await filtrar(filter);
  };

  const AutorizarCellRenderer = ({ data }) => (
    <div className="d-flex align-items-center justify-content-center">
      {
        <>
          <button
            title="Autorizar"
            type="button"
            className="button-icon"
            onClick={() => autorizar(data.id)}
          >
            <i className="pi pi-check-circle text-success" />
          </button>
        </>
      }
    </div>
  );
  const RechazarCellRenderer = ({ data }) => (
    <div className="d-flex align-items-center justify-content-center">
      {
        <>
          <button
            title="Cancelar"
            type="button"
            className="button-icon"
            onClick={() => autorizar(data.id, true)}
          >
            <i className="pi pi-times-circle text-danger" />
          </button>
        </>
      }
    </div>
  );
  const NivelCellRenderer = (value) => {
    const prioridad = value?.data?.prioridad;

    if (prioridad === constantesAdministracion.prioridadRequisicion.Nivel1) {
      return (
        <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
          <img src="../../../../img/nivel1.png" alt="Nivel 1" width="15px" />
          Nivel 1
        </span>
      );
    }

    if (prioridad === constantesAdministracion.prioridadRequisicion.Nivel2) {
      return (
        <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
          <img src="../../../../img/nivel2.png" alt="Nivel 2" width="15px" />
          Nivel 2
        </span>
      );
    }

    if (prioridad === constantesAdministracion.prioridadRequisicion.Nivel3) {
      return (
        <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
          <img src="../../../../img/nivel3.png" alt="Nivel 3" width="15px" />
          Nivel 3
        </span>
      );
    }

    return null;
  };

  const cambiarEstatus = async (requisicionIdArticulo, estatusId) => {
    const formData = serialize(
      { estatus: estatusId },
      { indices: true, dotsForObjectNotation: true }
    );
    await apiReq.cambiarEstatus(requisicionIdArticulo, formData);
  };
  const cambiarFechaEntrega = async (requisicionIdArticulo, fechaEntrega) => {
    const formData = serialize(
      { fechaEntrega: fechaEntrega },
      { indices: true, dotsForObjectNotation: true }
    );
    await apiReq.cambiarFechaEntrega(requisicionIdArticulo, formData);
    //await filtrar(filter);
  };

  const abrirCargasParaRequisicion = async (event, requisicion) => {
    setRequisicionSeleccionada(requisicion);
    const resultado = await apiReq.obtenerArticulos(requisicion.id);

    setArticulos(resultado.articulos);
    //console.log('articulos', resultado.articulos);
    op.current.toggle(event);

    setTimeout(() => {
      const el = document.getElementById("overlay_panel");
      if (el) {
        el.style.top = "160px";
        el.style.left = "50%";
        el.style.transform = "translateX(-50%)";
      }
    }, 0);
  };

  const renderFooterModal = () => (
    <div>
      <Button
        label="Cerrar"
        onClick={() => setVerRechazarModal(false)}
        className="p-button-outlined"
      />
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-danger"
        onClick={() => rechazarApi(requisicionIdARechazar)}
      />
    </div>
  );

  return (
    <div className="main-screen caja">
      <FormFilter
        columns={8}
        filter={filter}
        onChange={onFilterChange}
        onClear={onClear}
        onFilter={filtrar}
      >
        <Filters>
          <Field
            field={"folio"}
            label={"No Requisición"}
            render={FormTextBox}
            cols={1}
          />
          <Field
            field={"fecha"}
            label={"Fecha"}
            render={FormCalendarRange}
            cols={1}
          />
          <Field
            field={"solicitanteIds"}
            label={"Solicitante"}
            source="empleados"
            params={{ todasLasEmpresas: true }}
            render={FormMultiSelect}
            cols={2}
            showFilter
          />
          <Field
            field="almacenId"
            label="Almacen Destino"
            source={"empresas"}
            render={FormDropDown}
            cols={1}
          />
          <Field
            field="unidadId"
            label="Unidad"
            source="unidades"
            render={FormDropDown}
            cols={2}
          />

          <Field
            name="estatusId"
            field="estatusId"
            source="estatusRequisiciones"
            label="Estatus"
            colLg={3}
            colMd={3}
            render={FieldMultiSelect}
          />
        </Filters>
        <Buttons filter={true} clear={true}></Buttons>
      </FormFilter>
      <div
        className="ag-theme-balham grid-principal"
        style={{ height: "500px", width: "100%" }}
      >
        <AgGridReact
          components={{
            buttonsHeader: ButtonsHeader,
            buttonsDetail: ButtonsDetail,
            autorizarCellRenderer: AutorizarCellRenderer,
            rechazarCellRenderer: RechazarCellRenderer,
            dateCellRenderer: DateCellRenderer,
            nivelIncidenciaCellRenderer: NivelCellRenderer,
          }}
          onGridReady={onGridReady}
          rowData={datos}
          overlayLoadingTemplate={agGridHelper.loadingOverlay}
          defaultColDef={agGridHelper.defaultColumns}
          context={{ onEdit: (id) => setrequisicionId(id) }}
          rowSelection={"multiple"}
        >
          <AgGridColumn
            maxWidth={40}
            headerCheckboxSelection={true}
            checkboxSelection={true}
            hide={byOrdenTrabajo}
          />
          <AgGridColumn
            field="id"
            headerName="No Requisición"
            cellClass="center"
            flex={1}
            minWidth={100}
          />

          <AgGridColumn
            maxWidth={100}
            field="Prioridad"
            cellClass={"imagen"}
            cellRenderer="nivelIncidenciaCellRenderer"
          />

          <AgGridColumn
            field="unidad"
            headerName="Unidad"
            cellClass="center"
            cols={1}
            flex={1}
            minWidth={120}
          />
          <AgGridColumn
            field="comentarios"
            headerName="Comentarios"
            cellClass="center"
            cols={1}
            flex={1}
            minWidth={550}
          />
          <AgGridColumn
            field="estatus"
            headerName="Estatus"
            cellClass="center"
            cols={1}
            flex={1}
            minWidth={100}
          />
          <AgGridColumn
            maxWidth={100}
            hide={!esSeccionAutorizar}
            headerName="AUTORIZAR"
            cellRenderer="autorizarCellRenderer"
          />
          <AgGridColumn
            maxWidth={100}
            hide={!esSeccionAutorizar}
            headerName="CANCELAR"
            cellRenderer="rechazarCellRenderer"
          />

          <AgGridColumn
            field="fechaRequisicion"
            headerName="Fecha"
            cellClass="center"
            cellRenderer="dateCellRenderer"
            cols={1}
            flex={1}
            minWidth={100}
          />
                    <AgGridColumn
            field="almacenDestino"
            headerName="Almacen Destino"
            cellClass="center"
            cols={1}
            flex={1}
            minWidth={100}
          />
          <AgGridColumn
            field="articulos"
            headerName="Articulos"
            cellClass="center"
            flex={1}
            minWidth={240}
            cellRendererFramework={({ data, value, e }) => (
              <span
                className="link"
                style={{
                  cursor: "pointer",
                  color: "#007bff",
                  textDecoration: "underline",
                }}
                onClick={(event) => abrirCargasParaRequisicion(event, data)}
              >
                {value}
              </span>
            )}
          />

          <AgGridColumn
            maxWidth={80}
            headerName="VER"
            pinned={"right"}
            headerComponent="buttonsHeader"
            headerComponentParams={{
              api: apiReq,
              filtroState: filtroState,
            }}
            cellClass={"left"}
            cellRenderer="buttonsDetail"
          />
        </AgGridReact>
        <Dialog
          header={"Cancelar Requisicion"}
          visible={verRechazarModal}
          footer={renderFooterModal}
          style={{ width: "60vw" }}
          onHide={() => setVerRechazarModal(false)}
        >
          <FieldTextArea
            name={"comentarios"}
            label={"Comentarios"}
            colMd={12}
            rows={3}
            value={comentario}
            onChange={(value) => setComentario(value)}
          />
        </Dialog>

        <Dialog
          header={"Rechazar requisicion"}
          visible={verModal}
          footer={renderFooterModal}
          style={{ width: "60vw" }}
          onHide={() => setVerModal(false)}
        >
          <FieldTextArea
            name={"comentario"}
            label={"Comentarios"}
            colMd={12}
            rows={3}
            value={comentario}
            onChange={(value) => setComentario(value)}
          />
        </Dialog>
        <OverlayPanel
          ref={op}
          showCloseIcon
          id="overlay_panel"
          style={{ width: "1500px" }}
          className="overlaypanel-demo"
        >
          <ExGrid data={articulos} getEntityId={(row, index) => index}>
            <ExColumn title="Categoria" field="categoria" width="4fr" />
            <ExColumn title="Descripcion" field="descripcion" width="6fr" />
            <ExColumn title="Estatus" field="estatusNombre" width="4fr" />
            <ExColumn title="Codigo" field="codigo" width="6fr" />
            <ExColumn title="Cantidad" field="cantidad" width="2fr" />
            <ExColumn
              title="Fecha Compromiso"
              field="fechaCompromiso"
              width="3fr"
              cellRenderer={fechaRenderer}
            />
            <ExColumn
              title="Fecha entrega"
              width="220px"
              cellRenderer={({ row, ...props }) => (
                <FormCalendar
                  {...props}
                  value={row.fechaEntrega ? new Date(row.fechaEntrega) : null}
                  onChange={(e) => {
                    const fecha = e;
                    console.log("fechaEntrega change", row.id, fecha);
                    cambiarFechaEntrega?.(row.id, fecha);
                    const updatedArticulos = articulos.map((articulo) =>
                      articulo.id === row.id
                        ? {
                            ...articulo,
                            fechaEntrega: fecha ? fecha.toISOString() : null,
                          }
                        : articulo
                    );

                    setArticulos(updatedArticulos);
                  }}
                  showIcon
                  dateFormat="dd/mm/yy"
                  placeholder="Sin fecha"
                  showButtonBar
                  showTime={false}
                />
              )}
            />

            <ExColumn title="Comentarios" field="comentarios" width="4fr" />
            <ExColumn
              title="Estatus"
              width="200px"
              cellRenderer={({ row, ...props }) => (
                <Dropdown
                  {...props}
                  value={row.estatusId}
                  options={estatusRequisicionesArticulos}
                  optionLabel="nombre"
                  optionValue="id"
                  onChange={(e) => {
                    const estatusId = e.value;
                    cambiarEstatus?.(row.id, estatusId);
                    const updatedArticulos = articulos.map((articulo) =>
                      articulo.id === row.id
                        ? {
                            ...articulo,
                            estatusId: estatusId,
                            estatusNombre: getEstatusNombre(estatusId),
                          }
                        : articulo
                    );

                    setArticulos(updatedArticulos);
                  }}
                  placeholder="Selecciona estatus"
                />
              )}
            />
          </ExGrid>
        </OverlayPanel>
      </div>
      <RequisicionDetalle
        requisicionId={requisicionId}
        puedeEditar={puedeEditar}
        onSaved={() => {
          filtrar(filter).then();
          setrequisicionId(null);
        }}
        onCancel={() => setrequisicionId(null)}
        onRefresh={() => filtrar(filter).then()}
        soloLectura={soloLectura}
      />

      <Articulos
        value={requisicionSeleccionada || { articulos: [] }}
        visible={agregarArticulos}
        onClose={() => setAgregarArticulos(false)}
        onSaved={() => {
          filtrar(filter).then();
          setAgregarArticulos(false);
        }}
        requisicionId={id}
      />
    </div>
  );
};

export default Requisicion;
